var next = __webpack_require__.x;
__webpack_require__.x = function() {
	return __webpack_require__.e(2899).then(next);
};